import * as React from 'react';
import { UIText2 } from '@cian/ui-kit/typography';

import * as styles from './styles.css';

export interface IFIOSuggestion {
  value: string;
}

export interface ISuggestProps {
  suggest: IFIOSuggestion[];
  handleClickItem(value: string): void;
}

export function Suggest({ suggest, handleClickItem }: ISuggestProps) {
  return (
    <div className={styles['fio-suggest']} data-testid="fio-suggest-list">
      {suggest.map(item => {
        return (
          <div key={item.value} className={styles['fio-item']} onClick={() => handleClickItem(item.value)}>
            <UIText2 display="inline">{item.value}</UIText2>
          </div>
        );
      })}
    </div>
  );
}
